import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { InsertSubstructureBody, SearchSubstructuresResponse, UpdateSubstructureBody } from "./types/substructures";

export const useDeckSubstructuresApi = () => {
  const crud = createAdminCrudApi<SearchSubstructuresResponse, InsertSubstructureBody, UpdateSubstructureBody>(
    useApi(),
    DECK_ADMIN_URL,
    "substructures",
  );

  return {
    useDeckSubstructures: crud.useSearch,
    insertDeckSubstructure: crud.insert,
    updateDeckSubstructure: crud.update,
    deleteDeckSubstructure: crud.remove,
    updateDeckSubstructureVisibility: crud.updateVisibility,
    updateDeckSubstructureOrder: crud.updateOrder,
    generateUploadImageUrl: crud.generateUploadImageUrl,
    uploadImage: crud.uploadImage,
  };
};

export default useDeckSubstructuresApi;
